module.exports = __webpack_public_path__ + "static/img/tjhyk2.11c8e11.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/tjhyk2.png
// module id = 9gsS
// module chunks = 1